module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Probe name"},"it":{"title":"Nome della sonda"}}')
  delete Component.options._Ctor
}
